"use strict";

exports.__esModule = true;
exports.OrderSelectorDefinitions = exports.ORDER_SELECTOR_ODLEST_CREATION_TIME = exports.ORDER_SELECTOR_LATEST_CREATION_TIME = exports.ORDER_SELECTOR_ALPHABETICAL = void 0;
exports.getOrderSelectorDefinition = getOrderSelectorDefinition;
var ORDER_SELECTOR_ALPHABETICAL = exports.ORDER_SELECTOR_ALPHABETICAL = "alphabetic";
var ORDER_SELECTOR_LATEST_CREATION_TIME = exports.ORDER_SELECTOR_LATEST_CREATION_TIME = "latest-creation-time";
var ORDER_SELECTOR_ODLEST_CREATION_TIME = exports.ORDER_SELECTOR_ODLEST_CREATION_TIME = "oldest-creation-time";
var OrderSelectorDefinitions = exports.OrderSelectorDefinitions = [{
  name: ORDER_SELECTOR_ALPHABETICAL,
  label: "Alphabetic"
}, {
  name: ORDER_SELECTOR_LATEST_CREATION_TIME,
  label: "Latest creation time"
}, {
  name: ORDER_SELECTOR_ODLEST_CREATION_TIME,
  label: "Oldest creation time"
}];

/**
 * Get the definition for the order selector with the given name.
 */
function getOrderSelectorDefinition(name) {
  for (var i = 0; i < OrderSelectorDefinitions.length; i++) {
    var definition = OrderSelectorDefinitions[i];
    if (definition.name === name) {
      return definition;
    }
  }
  throw new Error("Unknown order selector: " + name);
}